export default __webpack_public_path__ + "static/media/landingBackground.2b7541b7.mp4";